import { ImageSuiteAppProps, ModelImageFXName } from "../../../../Helper";
import { Box, Typography } from "@mui/material";
import { InputText } from "../Shared/InputText";
import { SuiteAppSettings } from "../Shared/SuiteAppSettings";
import { AppActionButton } from "../Shared/AppActionButton";
import { OutputImage } from "../Shared/OutputImage";
import "../../../SharedSuite/Suites.css";
import SignalRService from "../../../one-query/services/SignalRService";
import { useImageSuiteGenerateLogo } from "../../../../store/Apis/SuitesApps/ImageSuitesApi";
import { useEffect } from "react";
import { useAppSelector } from "../../../../store/hooks";
import { appContainerStyle, appInputOutputContainerStyle } from "../Shared/styles";

export const LogoGeneratorApp = ({
  example,
  imageSettings,
  handelGenerateRandomPrompt,
  IsGeneratePromptLoading,
  isGenerateButtonDisabled,
  generatedPrompt,
  generatedImg,
  isGenerateImgLoading,
  selectedModel,
  getErrorMessage,
  selectedSize,
  seed,
  toggleLockSeed,
  openLockSeed,
  setSelectedModel,
  setSelectedSize,
  inputValue,
  setInputValue,
  handleOpenExpandImage,
  handleSetIsLoading,
    handelImprovePrompt,
  isImagePromptImproving,
  creditsNeeded
}: ImageSuiteAppProps) => {
  const appSuiteCosts=useAppSelector((s)=>s.User.AppSuiteCosts)
  const { mutate: GenerateLogoRequest, isPending: IsGenerateLogoLoading,error } =
    useImageSuiteGenerateLogo();

  useEffect(() => {
    if (IsGenerateLogoLoading) {
      handleSetIsLoading(true);
    }
  }, [IsGenerateLogoLoading]);
  useEffect(() => {
    if (error ) {
      getErrorMessage(error);
    }
   }, [error]);
  const handleGenerateLogo = async (
    inputValue: string,
    selectedModel: string,
    selectedSize: string
  ) => {
    if (inputValue && inputValue?.trim() !== "") {
      const connectionId = await SignalRService.getInstance().getConnectionId();

      const RequestData = {
        prompt: inputValue,
        connectionId: connectionId,
        modelName: selectedModel,
        imageRatio: selectedSize,
        // seed:!openLockSeed?seed:null
      };
      GenerateLogoRequest(RequestData);
    }
  };

  const handleSelectModel = (model: string) => {
    setSelectedModel(model);
  };

  const handleSelectSize = (size: string) => {
    setSelectedSize(size);
  };

  const handleGenerationAction = () => {
    if (inputValue && selectedModel && selectedSize) {
      handleGenerateLogo(inputValue, selectedModel, selectedSize);
    }
  };

  return (
    <Box sx={appContainerStyle}>
      <Box className="image-suites-input-header">
          <Typography className="image-suites-input-header-title">
            Transform text into stunning logos.
          </Typography>
        </Box>
    <Box sx={appInputOutputContainerStyle}>
      <Box className="image-suites-input">
        <Box className="image-suites-input-failed">
          <Typography className="settings-title">Prompt</Typography>
          <InputText
            example={example}
            inputValue={inputValue}
            setInputValue={setInputValue}
            generatedPrompt={generatedPrompt}
            isGenerateImgLoading={isGenerateImgLoading}
            IsGeneratePromptLoading={IsGeneratePromptLoading}
            handelGenerateRandomPrompt={handelGenerateRandomPrompt}
            handelImprovePrompt={handelImprovePrompt}
            isImprovePromptDisabled={isImagePromptImproving}
          />
          <SuiteAppSettings
            selectedSize={selectedSize}
            imageSettings={imageSettings}
            selectedModel={selectedModel}
            toggleLockSeed={toggleLockSeed}
            openLockSeed={openLockSeed}
            seedValue = {seed}
            handleSelectSize={handleSelectSize}
            handleSelectModel={handleSelectModel}
            showSetting={{ models: true, dimensions: true, seed: true }}
          />
        </Box>
        <AppActionButton
          creditsCount = {creditsNeeded?? 0}
          inputValue={inputValue}
          appMethodFire={handleGenerationAction}
          IsGeneratePromptLoading={IsGeneratePromptLoading}
          isGenerateButtonDisabled={isGenerateButtonDisabled}
        />
      </Box>
      <Box className="image-suites-output">
        <Box className="image-suites-output-result">
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Typography className="image-suites-output-result-placeholder">
              {isGenerateImgLoading || generatedImg ?  "Output":"Sample Output"}
            </Typography>
            <OutputImage
              slider={false}
              outputImage={true}
              imgUrl={generatedImg}
              exampleImgUrl={example.path}
              isLoading={isGenerateImgLoading}
              handleOpenExpandImage={handleOpenExpandImage}
            />
          </Box>
        </Box>
      </Box>
    </Box>
    </Box>
  );
};
